// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"705c2919","716":"a219f463"}[chunkId] + ".chunk.js";
};